import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import * as React from 'react';

import SellerTableRow from './SellerTableRow';

type Props = {
    className?: string;
    sellerIds: number[];
};

const SellerTable = ({ className = '', sellerIds = [] }: Props) => (
    <table className={cn('mt-xs w-full border-collapse', className)}>
        <thead>
            <tr>
                <th>
                    <FormattedMessage id="auctioneer" />
                </th>
                <th className="xsMax:hidden">
                    <FormattedMessage id="upcoming_auct" />
                </th>
                <th className="text-right">
                    <FormattedMessage id="unfollow" />
                </th>
            </tr>
        </thead>
        <tbody>
            {sellerIds.map(
                React.useCallback(
                    (sellerId) => (
                        <SellerTableRow
                            key={sellerId}
                            sellerId={sellerId}
                        />
                    ),
                    []
                )
            )}
        </tbody>
    </table>
);

export default SellerTable;
